import { useState } from 'react'

import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { SERVICE_BOOKING_CONFIRM_PATH } from '@/services'

export const useConfirmBookingRepair = (tokenId, config = {}) => {
  const api = useLegacyPublicApi()
  const { formatMessage } = useIntl()
  const [errorMessage, setErrorMessage] = useState(null)

  const { mutateAsync: mutate, isLoading } = useMutation({
    mutationFn: async () => {
      if (!api || !tokenId) {
        return false
      }
      const url = SERVICE_BOOKING_CONFIRM_PATH.replace('{tokenId}', tokenId)
      const { data: responseData } = await api.post(url, {
        tokenId,
        confirm: true,
      })
      return responseData
    },
    onError: (error) => {
      if (error) {
        const serverErrorMessage =
          error.response?.data?.length > 0
            ? error.response.data[0].Description
            : null
        setErrorMessage(
          `${formatMessage({
            id: 'page.bookingWizard.arrival-error',
          })} - ${serverErrorMessage}`,
        )
      }
    },
    ...config,
  })
  const confirmArrivalBookingRepair = () => mutate()
  return { confirmArrivalBookingRepair, isLoading, errorMessage }
}

export default useConfirmBookingRepair
